export default __webpack_public_path__ + "static/media/aws.0510b15a.svg";